export default {
  functionKey: "ISOLER",
  title: "ISOLER",
  group: "Organisation",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 2,
  requiredArguments: [
    { argumentKey: "Start", name: "Borne inférieure" },
    { argumentKey: "End", name: "Borne supérieure", empty: true }
  ],
  expectedArguments: [
    { name: "Borne inférieure", argumentKey: "Start", single: true, initialValue: "0" },
    { name: "Borne supérieure", argumentKey: "End", single: true, initialValue: "0" }
  ],
  description: "Extraire les caractères entre deux indexes. (Ex: (ISOLER 'helloworld', 2, 5) -> 'llo')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    if (args.length === 0) args.push("0");
    if (args[0] === "''") args[0] = "0";
    const code = `${destination} = ${origin}.substring(${args[0]}${(args[1] && args[1] !== "''") ? ", " + args[1] : ""});`;
    return { displayCode: code, safeCode: code };
  }
}
